<template>
  <div class="home">
    <!-- 表头区域 -->
        <PageHeaders></PageHeaders>
    <div class="home-top">
      <div class="title">安全 · 可靠 · 权威的公共服务平台</div>
      <!-- 搜索区域 -->
      <div class="search">
        <div class="search-top">
          <div class="search-box" style="width: 145px">
            <el-select v-model="value1" placeholder="请选择">
              <el-option
                  v-for="item in options1"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="search-box"  style="width: 235px" v-if="value1 === '0'">
            <el-select v-model="value2" placeholder="请选择">
              <el-option
                  v-for="item in options2"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="search-box"  style="width: 235px" v-if="value1 === '1'">
            <el-select v-model="value3" placeholder="请选择">
              <el-option
                  v-for="item in options3"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="search-box" style="width: 295px">
            <el-input v-model="name" placeholder="请输入"></el-input>
          </div>
          <el-button type="primary" size="mini" style="width: 86px;height: 40px;font-size: 14px"  icon="el-icon-search" @click="search">搜索</el-button>
        </div>
        <div class="tips">该搜索为精确查询，请准确输入名称</div>

      </div>
    </div>
    <!-- 新闻小滑块 -->
    <div class="news">
      <div class="news-title" @click="goPage('/news')"><img src="static/icon-news.png" style="margin-right: 10px" />新闻信息</div>

      <div v-for="item in newsList" class="news-list" @click="goDetail('/newsDetail', item)"><div class="point"></div>{{ item.title }}</div>

    </div>

    <!-- 信息展示 -->
    <div class="card-box">
      <div v-for="item in cardList" class="card" :class="item.back" @click="goPage(item.router)">
        <div class="title">{{ item.title}}<i class="el-icon-arrow-right"></i></div>
        <div class="explain">{{ item.explain }}</div>
        <div style="margin-top: 10px">
          <span style="font-size: 20px">{{ Statistics[item.num] }}</span>
          <span style="margin-left: 5px">{{ item.unit }}</span>
        </div>
      </div>
    </div>

    <el-dialog
        v-if="dialogVisible"
        title="使用声明"
        :visible.sync="dialogVisible"
        width="640px"
        height="360"
        :before-close="handleClose">
      <div style="display: flex;flex-direction: column">
        <span style="text-align: left">化学品登记中心全面真实地提供了化学品安全数据查询， 但我们并不能保证相关数据绝对的精确性和适用性。 本网站提供的数据仅供用户参考，用户在生产、使用、储存、运输、处置相关化学品时， 需根据实际情况作出独立的判断。用户使用本网站数据所导致的伤害和损失， 化学品登记中心不负任何责任。 本网站免费提供化学品数据查询， 任何单位和个人未经允许不得用于商业目的。</span>
        <el-checkbox v-model="checked">阅读并同意</el-checkbox>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="agree" :disabled="!checked">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import {queryContentList, queryHomeStatistics} from "@/api";
import PageHeaders from "@/components/Headers";
export default {
  name: "home",
  components: {PageHeaders},
  data(){
    return{
      Statistics: {},
      chmCount: "",
      companyCount: "",
      graphCount: "",
      knowledgeCount: "",
      sdsCount: "",
      trainCount: "",
      options1: [{
        value: '0',
        label: '企业'
      }, {
        value: '1',
        label: '化学品'
      },],
      options2: [{
        value: '0',
        label: '企业名称'
      }, {
        value: '1',
        label: '企业登记证号'
      },{
        value: '2',
        label: '统一社会信用代码'
      },],
      options3: [{
        value: '0',
        label: '化学品名称'
      }, ],
      value1: '0',
      value2: '0',
      value3: '0',
      name: "",
      newsList: [],
      cardList: [
        {title: "化学品登记企业信息查询平台", explain: "公开全国危化品企业基本情况", num: "companyCount", unit: "家", back: 'card1', router: "/companyData"},
        {title: "化学品安全信息平台", explain: "技术信息档案库公开查询", num: "chmCount", unit: "种", back: 'card2', router: "/chemicalsData"},
        {title: "一企一品一码查询", explain: "危化品的终身“身份”凭证", num: "sdsCount", unit: "个", back: 'card3', router: "/chemicalsQrCode"},
        {title: "知识图谱技术展示", explain: "技术展示", num: "graphCount", unit: "种", back: 'card4', router: "/knowledgeGraph"},
        {title: "危险化学品实训基地", explain: "实训演练", num: "trainCount", unit: "座", back: 'card5', router: "/trainingBase"},
        {title: "知识园地", explain: "危化品相关知识", num: "knowledgeCount", unit: "个", back: 'card1', router: "/gardenOfKnowledge"},
      ],
      dialogVisible: false,
      checked: false,
    }
  },
  mounted() {
    this.getData()
    this.getNews()
  },
  methods: {
    goPage(router){
      this.$router.push(router)
    },
    goDetail(router, obj){
      // let host = window.location.protocol + "//" + window.location.host + '/#' + router + '?id=' + obj.id; 路由
      let host = window.location.protocol + "//" + window.location.host + '/publicInternet' + router + '?id=' + obj.id;
      window.open(host);
    },
    // 搜索
    search(){
      if(!this.name){
        this.$message.error('请输入搜索内容')
      }else if(this.value1 === '0'){
        this.$router.push('/companyData?value=' + this.value2 + '&data=' + this.name)
      }else if(this.value1 === '1'){
        this.dialogVisible = true
        // this.$router.push('/chemicalsData?value=' + this.name)
      }
    },
    // 获取统计数据
    getData(){
      queryHomeStatistics({}).then(res => {
        this.Statistics = res.obj
      })
    },
    // 获取新闻数据
    getNews(){
      this.loading = true
      let data = {
        status: "1",
        menuId: '1',
        page: {
          current: 1,
          size: 4,
        },
      }
      queryContentList(data).then(res => {
        this.newsList = res.obj.records
      }, () => {
        this.loading = false
      })
    },
    handleClose(){
      this.dialogVisible = false
    },
    agree(){
      if(this.checked){
        this.dialogVisible = false
        this.$router.push('/chemicalsData?value=' + this.name)
      }else{

      }
    },
  },
}
</script>

<style scoped lang="scss">
.home{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  .home-top{
    width: 100%;
    height: 654px;
    background-image: url('/public/static/home-back.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    .title{
      font-size: 40px;
      color: #fff;
      font-weight: bold;
      text-shadow: 0px 6px 5px rgba(1,49,136,0.33);
    }
    .search{
      width: 848px;
      height: 100px;
      background: #FFFFFF;
      border: 1px solid #3499DE;
      border-radius: 10px;
      margin-top: 101px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 0 20px;
      box-sizing: border-box;
      .search-top{
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
      }
      .tips{
        font-size: 12px;
        margin-top: 10px;
        color: #f00;
      }
    }
  }
  .news{
    width: 90%;
    height: 46px;
    background: #FFFFFF;
    box-shadow: 0px 2px 10px 0px rgba(26,30,40,0.16);
    border-radius: 5px;
    margin-top: -23px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding-right: 20px;
    box-sizing: border-box;
    .news-title{
      width: 205px;
      height: 45px;
      background-image: url('/public/static/news.png');
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-left: 40px;
      padding-left: 40px;
      box-sizing: border-box;
      font-size: 16px;
      color: #1D82D8;
      cursor: pointer;
    }
    .news-list{
      font-size: 12px;
      color: #7F7F7F;
      display: flex;
      flex-direction: row;
      align-items: center;
      cursor: pointer;
      .point{
        width: 5px;
        height: 5px;
        border-radius: 5px;
        background: #7F7F7F;
        margin-right: 10px;
      }
    }
    .news-list:hover{
      color: #1D82D8;
    }
  }
  .card-box{
    width: 90%;
    height: 149px;
    margin: 29px 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    .card{
      width: 15%;
      height: 149px;
      color: #fff;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      padding-left: 20px;
      box-sizing: border-box;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      .title{
        font-size: 14px;
        font-weight: bolder;
      }
      .explain{
        font-size: 12px;
        color: #fff;
        margin-top: 10px;
        opacity: 0.6;
      }
    }
    .card1{
      background-image: url('/public/static/card1.png');
    }
    .card2{
      background-image: url('/public/static/card2.png');
    }
    .card3{
      background-image: url('/public/static/card3.png');
    }
    .card4{
      background-image: url('/public/static/card4.png');
    }
    .card5{
      background-image: url('/public/static/card5.png');
    }
  }
}
</style>
